// reducer.js

import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  addNewJob,
  editApplicantService,
  editNewJob,
  getApplicantRole,
  getApplicantRoleById,
  getCategoryList,
  getCompanyRole,
  getCompanyRoleById,
} from "../../../../../utils/services/career/careerService";
import { toast } from "react-toastify";

const initialState = {
  companyRoleList: [],
  categoryList: [],
  companyRoleById: [],
  openPositionCount: 0,
  applicantsReviewd: 0,
  candidateHired: 0,
  currentPage: 0,
  currentPageLimit: 25,
  isLoading: false,
  total: 0,
  searchKey: "",
  searchCourseKey: "",

  applicantCurrentPage: 0,
  applicantCurrentPageLimit: 25,
  applicantIsLoading: false,
  applicantTotal: 0,
  applicantSearchKey: "",
  applicantList: [],
  applicantListById: [],
  trainerCount: 0,
  toBeReviewed: 0,
  hiredTrainers: 0,
};

//get company role list
export const fetchCompanyRole = createAsyncThunk(
  "/companyRole/fetch",
  async (_, thunkAPI) => {
    const { searchKey, currentPage, currentPageLimit } =
      thunkAPI.getState().career;

    const payload = {
      searchKey,
      currentPage: currentPage + 1,
      currentPageLimit,
    };

    try {
      const response = await getCompanyRole(payload);
      return response;
    } catch (error) {
      throw error;
    }
  }
);

//get category list
export const fetchCategoryList = createAsyncThunk(
  "/categoryList/fetch",
  async (_, thunkAPI) => {
    try {
      const response = await getCategoryList();
      return response;
    } catch (error) {
      throw error;
    }
  }
);

//get company role by id
export const fetchJobInfo = createAsyncThunk(
  "/companyRole/fetch/id",
  async (payload, thunkAPI) => {
    try {
      const response = await getCompanyRoleById(payload);
      return response;
    } catch (error) {
      throw error;
    }
  }
);

//add a new job
export const addNewJobCarrer = createAsyncThunk(
  "/addNewJob/career",
  async (payload, thunkAPI) => {
    const { response, error } = await addNewJob(payload);
    // thunkAPI.dispatch(fetchCompanyRole())

    // ?.response?.data?.message
    if (error) thunkAPI.rejectWithValue(error);
    // throw error;
    thunkAPI.dispatch(fetchCompanyRole());
    return response;
  }
);

//fetch applicant list
export const fetchApplicantList = createAsyncThunk(
  "/fetchApplicantList",
  async (cat, thunkAPI) => {
    const {
      applicantSearchKey,
      applicantCurrentPage,
      applicantCurrentPageLimit,
    } = thunkAPI.getState().career;

    const payload = {
      applicantSearchKey,
      applicantCurrentPage: applicantCurrentPage + 1,
      applicantCurrentPageLimit,
      category: cat,
    };

    try {
      const response = await getApplicantRole(payload);
      return response;
    } catch (error) {
      throw error;
    }
  }
);

//edit a new job
export const EditNewJobCarrer = createAsyncThunk(
  "/editNewJob/career",

  async (payload, thunkAPI) => {
    const { response, error } = await editNewJob(payload);
    if (error) {
      return error;
    }
    thunkAPI.dispatch(fetchCompanyRole());
    return response;
  }
);

//get applicant by id
export const fetchApplicantListById = createAsyncThunk(
  "/fetchApplicantList/id",
  async (payload, thunkAPI) => {
    try {
      const response = await getApplicantRoleById(payload);
      return response;
    } catch (error) {
      throw error;
    }
  }
);

//edit applicant
export const editApplicant = createAsyncThunk(
  "/editApplicant/career",

  async (payload, thunkAPI) => {
    try {
      const response = await editApplicantService(payload?.payload);
      thunkAPI.dispatch(fetchApplicantList(payload?.category));
      return response;
    } catch (error) {
      thunkAPI.rejectWithValue(error);
      // throw error;
    }
  }
);

export const careerSlice = createSlice({
  name: "course",
  initialState,
  reducers: {
    resetPaginationModel(state, action) {
      state.currentPage = 0;
      state.currentPageLimit = 10;
    },
    resetPaginationModelApplicant(state, action) {
      state.applicantCurrentPage = 0;
      state.applicantCurrentPageLimit = 10;
    },
    searchKeyChanged(state, action) {
      state.searchKey = action.payload;
    },

    setPaginationModel(state, action) {
      state.currentPageLimit = action.payload.pageSize;
      state.currentPage = action.payload.page;
    },
    setApplicantPaginationModel(state, action) {
      state.applicantCurrentPageLimit = action.payload.pageSize;
      state.applicantCurrentPage = action.payload.page;
    },
    applicantSearchKeyChanged(state, action) {
      state.applicantSearchKey = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchCompanyRole.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(fetchCompanyRole.fulfilled, (state, action) => {
      state.total = action?.payload?.payload?.dataCount;
      state.companyRoleList = action?.payload?.payload?.data;
      state.isLoading = false;
      state.applicantsReviewd = action?.payload?.payload?.toBeReviewedCount;
      state.candidateHired = action?.payload?.payload?.hiredCandidatesCount;
      state.openPositionCount = action?.payload?.payload?.openPositionCount;
    });
    builder.addCase(fetchCompanyRole.rejected, (state, action) => {
      state.isLoading = false;
    });
    builder.addCase(fetchCategoryList.pending, (state) => {});
    builder.addCase(fetchCategoryList.fulfilled, (state, action) => {
      state.categoryList = action?.payload?.payload;
    });
    builder.addCase(fetchCategoryList.rejected, (state, action) => {});

    builder.addCase(fetchJobInfo.pending, (state) => {});
    builder.addCase(fetchJobInfo.fulfilled, (state, action) => {
      state.companyRoleById = action?.payload?.payload;
    });
    builder.addCase(fetchJobInfo.rejected, (state, action) => {});
    builder.addCase(fetchApplicantList.pending, (state) => {
      state.applicantIsLoading = true;
    });
    builder.addCase(fetchApplicantList.fulfilled, (state, action) => {
      // trainerCount:0,
      // toBeReviewed:0,
      // hiredTrainers:0
      state.applicantList = action?.payload?.payload?.trainers
        ? action?.payload?.payload?.trainers
        : action.payload?.payload?.applicants;
      state.applicantIsLoading = false;
      state.applicantTotal = action.payload?.payload?.trainerCount
        ? action.payload?.payload?.trainerCount
        : action.payload?.payload?.count;
      state.trainerCount = action?.payload?.payload?.totalTrainers;
      state.toBeReviewed = action?.payload?.payload?.toBeReviewed;
      state.hiredTrainers = action?.payload?.payload?.hiredTrainers;
    });
    builder.addCase(fetchApplicantList.rejected, (state, action) => {
      state.applicantIsLoading = false;
    });
    // fetchApplicantListById
    builder.addCase(fetchApplicantListById.pending, (state) => {});
    builder.addCase(fetchApplicantListById.fulfilled, (state, action) => {
      state.applicantListById = action?.payload?.payload;
    });
    builder.addCase(fetchApplicantListById.rejected, (state, action) => {});

    //add new job career
    builder.addCase(addNewJobCarrer.pending, (state) => {});
    builder.addCase(addNewJobCarrer.fulfilled, (state, action) => {
      toast.success("Created Successfully");
    });
    builder.addCase(addNewJobCarrer.rejected, (state, action) => {});

    //edit new job
    builder.addCase(EditNewJobCarrer.pending, (state) => {});
    builder.addCase(EditNewJobCarrer.fulfilled, (state, action) => {
      toast.success("Updated Successfully");
    });
    builder.addCase(EditNewJobCarrer.rejected, (state, action) => {
      // toast.error("Something went wrong")
    });

    //edit applicant
    builder.addCase(editApplicant.pending, (state) => {});
    builder.addCase(editApplicant.fulfilled, (state, action) => {
      toast.success("Updated Successfully");
    });
    builder.addCase(editApplicant.rejected, (state, action) => {});
  },
});
export const {
  searchKeyChanged,
  applicantSearchKeyChanged,
  searchCourseKeyChanged,
  pageChanged,
  pageLimit,
  setPaginationModel,
  setApplicantPaginationModel,
  resetPaginationModel,
  resetPaginationModelApplicant,
} = careerSlice.actions;

export default careerSlice.reducer;
